export default __webpack_public_path__ + "static/media/fk.c7cc2fb7.svg";